import React from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import Selectors from '@/vocabularies/hooks/selectors';
import HiddenSpan from '@/components/HiddenSpan';

const HelpLink = () => {
  const { title, url } = Selectors.useHelpLink();
  return (
    <Menu.Item className="help aridhia-help-link">
      <a
        className="knowledgebase"
        href={url}
        target="_knowledgebase"
        rel="noopener noreferrer"
        data-tooltip={title}
        data-variation="mini"
        data-position="bottom center"
      >
        <HiddenSpan text={title} />
        <Icon name="question circle outline" className="primary" size="large" inverted />
      </a>
    </Menu.Item>
  );
};

export default HelpLink;
